// Single source of truth for the Sizers section's tabs. Used by BOTH the header
// "Sizers" dropdown (AuthenticatedDashboard) and the section's own sticky tab
// strip (SizersLayout) so they never drift apart.
//
// The sizers lived under Admin (/admin/sizers/*) until 2026-10-15; they moved to
// their own top-level section so non-admins in the "Sizer Visibility" group can
// use them (see hooks/useCanSeeSizers.js). The old /admin/sizers/* links
// redirect here (index.js).
//
// All of them run on the LOS pricing router's scenario endpoints —
// /pricing/scenario/{rtl, max_leverage, dscr_quick} — which price and screen
// without creating a deal.
export const SIZERS_ROOT = "/sizers";

export const SIZER_TABS = [
  // Priced surfaces first, in the order a desk reaches for them, with the
  // no-rate quick check after the full sizers. Priced Scenarios is the read
  // side: every priced run the sizers persisted, with its reprice history
  // (GET /pricing/scenarios).
  { to: "/sizers/scenarios", label: "Priced Scenarios" },
  { to: "/sizers/rtl", label: "RTL Sizer" },
  // The GUC-dedicated surface. Same endpoint and same rules as the tab above —
  // what differs is the RESULT: lean by default, with the verbose read behind
  // "Explain this result" (GUC_SIZER_V2_FRONTEND_SPEC.md).
  { to: "/sizers/guc", label: "GUC Sizer" },
  // ONE DSCR entry. Full Entry and Quick Entry are two depths of the same
  // sizer — same endpoint, same answer — so they are a switcher under the page
  // title (`?entry=quick`), not two places to go.
  { to: "/sizers/dscr", label: "DSCR Sizer" },
  { to: "/sizers/max-leverage", label: "Max Leverage" },
];

/**
 * The DSCR Sizer is SUPER-ADMIN ONLY (owner 2026-10-16): everyone else who can
 * see the Sizers section — admins and the "Sizer Visibility" group — gets every
 * tab except DSCR. One rule, read by the header menu, the tab strip, the route
 * (AdminSizersScreen) and Priced Scenarios (`useCanUseDscrSizer`).
 */
export const DSCR_SIZER_PATH = "/sizers/dscr";

export const visibleSizerTabs = ({ canUseDscr }) =>
  SIZER_TABS.filter((t) => canUseDscr || t.to !== DSCR_SIZER_PATH);

// The sticky tab strip's height (SectionSubTabs "page": 12 + 20 + 12 + 3px
// indicator). The scenario workspace header pins directly under it.
export const SIZER_TABS_H = 47;
